import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectoDocumentacionDTO, ProyectoParticipantesDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProyectoDocumentacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getProyectoDocumentacionService(): Observable<BodyListResponse<ProyectoDocumentacionDTO>> {
    return this.http.get<BodyListResponse<ProyectoDocumentacionDTO>>(API_URL + '/api/v1/proyectoDocumentacion/todos');
  }

  guardarProyectoDocumentacionService(proyectoDocumentacionDTO: ProyectoDocumentacionDTO): Observable<BodyResponse<ProyectoDocumentacionDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/proyectoDocumentacion', proyectoDocumentacionDTO);
  }

  getProyectoDocumentacionPorCodigoService(codigo: string): Observable<BodyResponse<ProyectoDocumentacionDTO>> {
    return this.http.get<BodyResponse<ProyectoDocumentacionDTO>>(API_URL + '/api/v1/proyectoDocumentacion/' + codigo);
  }

  getProyectoDocumentacionParticipanteProyectosService(codigoEstudiante: string, codigoProyecto: string, orden: string): Observable<BodyListResponse<ProyectoDocumentacionDTO>> {
    console.log(API_URL + '/api/v1/proyectoDocumentacion/generarListadoDocumentos/' + codigoEstudiante + '/' + codigoProyecto + '/' + orden)
    return this.http.get<BodyListResponse<ProyectoDocumentacionDTO>>
      (API_URL + '/api/v1/proyectoDocumentacion/generarListadoDocumentos/' + codigoEstudiante + '/' + codigoProyecto + '/' + orden);
  }

  getProyectoDocumentacionNotificarService(codigoEstudiante: string, codigoProyecto: string, orden: string, codugoUsuarioConectado: string): Observable<BodyResponse<ProyectoDocumentacionDTO>> {
    return this.http.get<BodyResponse<any>>(API_URL + '/api/v1/proyectoDocumentacion/notificacionTutorRevision/' + codigoEstudiante + '/' + codugoUsuarioConectado + '/' + codigoProyecto + '/' + orden);
  }

  getProyectoDocumentacionNotificarEstudianteService(codigoTutor: string, codigoProyecto: string, orden: string): Observable<BodyResponse<ProyectoDocumentacionDTO>> {
    return this.http.get<BodyResponse<any>>(API_URL + '/api/v1/proyectoDocumentacion/notificacionEstudianteRevision/' + codigoTutor + '/' + codigoProyecto);
  }
  /**buscar documentacion por estudiante  */

  obtenerProyectoDocumentacionParticipanteProyectosService(codigoEstudiante: string, codigoUsuarioConectado: string, codigoProyecto: string, orden: string): Observable<BodyListResponse<ProyectoDocumentacionDTO>> {
    return this.http.get<BodyListResponse<ProyectoDocumentacionDTO>>
      (API_URL + '/api/v1/proyectoDocumentacion/consultarDocumentosrevision/' + codigoEstudiante + '/' + codigoUsuarioConectado + '/' + + codigoProyecto + '/' + orden);
  }

  procesarProyectoDocumentacionCambioFlujoService(proyectoparticipante: ProyectoParticipantesDTO, operacion: string, codigoUsuarioConectado: string): Observable<BodyResponse<ProyectoDocumentacionDTO>> {    
    return this.http.post<any>(API_URL + '/api/v1/proyectoDocumentacion/actualizarFlujoTrabajo/' + operacion + '/' + codigoUsuarioConectado, proyectoparticipante);
  }

}
